import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/************* GET STAFF OFFICER REPORT START ************************** */
export const staffReportDetailsGet = (fetchData: any) => {
	const data = {
		FetchStaffReportDetailsToken: fetchData,
	};
	const url = `${API_URL}GetStaffReportwithToken`;
	return makeApiCall(url, data);
};
/************* GET STAFF OFFICER REPORT END ************************** */

/************* GET STAFF OFFICER DETAIL START ************************** */
export const staffOfficerDetails = (fetchData: any) => {
	const data = {
		StaffOfficerToken: fetchData,
	};
	const url = `${API_URL}getListOfficerUserForBranch`;
	return makeApiCall(url, data);
};
/************* GET STAFF OFFICER DETAIL END ************************** */
